import React, { ReactElement } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Immutable from "immutable";

import { Client, Language } from "resourceModels";
import { State } from "reducers/types";
import { getResource, getResources } from "selectors/resources";
import Button from "components/Common/Button";

import "./style.scss";

interface PropsFromState {
  client: Client;
  languages: Immutable.List<Language>;
}

interface OwnProps {
  availableLanguages: Immutable.List<Language>;
  onLanguageClick(languageCode: string): void;
  closeDialog(): void;
}

type ResponseEditorLanguagesDialogProps = OwnProps & PropsFromState;

function ResponseEditorLanguagesDialog(props: ResponseEditorLanguagesDialogProps): ReactElement {
  const {
    client,
    languages,
    onLanguageClick,
    availableLanguages,
    closeDialog
  } = props;

  return (
    <div className="ResponseEditorLanguagesDialog">
      <div className="ResponseEditorLanguagesDialog__languages">
        {availableLanguages.map(
          language => (
            <Button
              text={language.englishName}
              title={language.englishName}
              customClassName="ResponseEditorLanguagesDialog__languages__language-button"
              key={language.id}
              onClick={() => {
                onLanguageClick(language.code);
                closeDialog();
              }}
              size="small"
              clear
            />
          )
        )}
      </div>
      {/*
          We subtract 1 here because languages includes the primary language,
          which does not need to be translated
        */}
      {languages.size - 1 !== client.translatedLanguages.size && (
        <p className="ResponseEditorLanguagesDialog__link-block g-form__block__description">
          Add languages to this list in&nbsp;
          <Link
            to="/settings/languages"
            className="ResponseEditorLanguagesDialog__link-block__link g-form__block__description"
          >
            Settings → Languages
          </Link>
        </p>
      )}
    </div>
  );
}

function mapStateToProps(state: State): PropsFromState {
  return {
    client: getResource(state, "client"),
    languages: getResources(state, "language")
  };
}

export default connect(mapStateToProps)(ResponseEditorLanguagesDialog);
